module.exports = __webpack_public_path__ + "static/hero-629d80d35814cbce24adc42b6bb873df.png";